export class CurrentStateIdValue {
    constructor(state, value) {
        this.state = state;
        this.value = value;
        this.state = state;
        this.value = value;
    }
}
